import type { Incident } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleDown } from 'react-icons/fa';
import { IncidentPdfMenuItem } from './IncidentPdfMenuItem';

interface Props extends ChakraV3.ButtonProps {
  incident: Incident;
}

export const IncidentActionMenu = (props: Props) => {
  const { incident, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <IncidentPdfMenuItem incident={incident} />
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='outline' size='sm' {...rest}>
          Actions
          <FaAngleDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
    </ChakraV3.Menu.Root>
  );
};
